<!-- @format -->

@if (showValidityPeriod) {
  <div class="form-group-mimic grouping-panel">
    @if (!hideLabel) {
      <div role="heading" class="sis-mb-xxs sis-label" [class.required]="required" [attr.aria-level]="level">
        <ng-template [ngTemplateOutlet]="organisationLabel"></ng-template>
      </div>
    }
    <div class="grouping-panel-content">
      @if (isCoordinatingOrganisation() && validityGroups.length === 0) {
        <ng-template [ngTemplateOutlet]="organisationGuidance"> </ng-template>
      }
      <sis-description-list [columnCount]="1">
        <dl>
          @for (validityGroup of validityGroups; track validityGroup) {
            <ng-template #listItem>
              <dt class="sis-label">{{ validityGroup.validityPeriod | localDateRange }}</dt>
              <dd>
                <ng-template
                  [ngTemplateOutlet]="organisationRoleShares"
                  [ngTemplateOutletContext]="{ shares: validityGroup.organisationRoleShares }"></ng-template>
              </dd>
            </ng-template>
          }
        </dl>
      </sis-description-list>
    </div>
  </div>
}

@if (!showValidityPeriod) {
  <div class="form-group-mimic">
    <sis-description-list [fillByColumn]="false">
      <dl>
        <ng-template #listItem>
          @if (!hideLabel) {
            <dt class="sis-label" [class.required]="required">
              <ng-template [ngTemplateOutlet]="organisationLabel"></ng-template>
            </dt>
          }
          <dd>
            @if (isCoordinatingOrganisation() && validityGroups.length === 0) {
              <ng-template [ngTemplateOutlet]="organisationGuidance"> </ng-template>
            }
            @for (validityGroup of validityGroups; track validityGroup) {
              <div class="form-group-mimic">
                <ng-template
                  [ngTemplateOutlet]="organisationRoleShares"
                  [ngTemplateOutletContext]="{ shares: validityGroup.organisationRoleShares }"></ng-template>
              </div>
            }
          </dd>
        </ng-template>
      </dl>
    </sis-description-list>
  </div>
}

<ng-template #organisationLabel>
  {{ getLabelKey() | translate }}
</ng-template>

<ng-template #organisationGuidance>
  <p class="sis-guidance" translate>SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE.COORDINATING_ORGANISATION_GUIDANCE</p>
</ng-template>

<ng-template #organisationRoleShares let-shares="shares">
  @for (share of shares; track share) {
    <p class="form-control-static">
      {{
        share.educationalInstitutionUrn
          ? (share.educationalInstitutionUrn | codeLocalizedName | async)
          : ((share.organisationId | organisation | async)?.name | localizedString)
      }}
      {{ share.share | percent }}
    </p>
  }
</ng-template>
